import React, { memo, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isArray, toString } from 'lodash';

import { Dropdown } from '../../Dropdown';
import { FilterTitle } from '../index';
import { ButtonFilter } from '../../Buttons';
import { useFilters } from '../../../providers/Filters/useFilters';
import Body from './Body';

const params = ['providers'];

const FilterProviders = ({ data, filterMethod, updateService }) => {
  const [filterData, setFilterData] = useState(data);
  const [isDataUpdated, setIsDataUpdated] = useState(false);
  const [sortBy, setSortBy] = useState(null);

  const { filters, onAddFiltersParams, onDeleteFilter } = useFilters();
  const filter = filters[filterMethod];

  const activeText = useMemo(() => {
    if (filter.hasOwnProperty('providers') && isArray(filterData)) {
      const providersFilterString = toString(filter.providers);
      const providersArray = providersFilterString.split(',');
      const activeFilters = filterData.filter((item) => !!(providersArray.includes(toString(item.id)) || providersArray.includes(item.id)));

      if (activeFilters.length > 1) {
        return `${providersArray.length} providers`
      }
      if (activeFilters.length) {
        return activeFilters.reduce((accumulator, currentValue, index) => {
          const lastFilter = activeFilters.length - 1 === index;
          accumulator += `${currentValue.label}${lastFilter ? '' : ', '}`
          return accumulator;
        }, '');
      }
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, filterData])

  const onClearFilter = (e) => {
    e.preventDefault();
    onDeleteFilter(params)
  }

  const onChangeFilterData = (filterData) => {
    if (filterData) {
      setFilterData(filterData);
      setIsDataUpdated(true);
    }
  }

  useEffect(() => {
    setFilterData(data);
    setIsDataUpdated(false);
    setSortBy(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  useEffect(() => {
    onAddFiltersParams(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dropdown.Root>
      <Dropdown.Trigger>
        <ButtonFilter
          name="Provider"
          activeText={activeText}
          onClear={onClearFilter}
        />
      </Dropdown.Trigger>
      <Dropdown.Container
        position="bottom"
        width={280}
      >
        <Dropdown.Header p={16}>
          <FilterTitle>Filter by Provider</FilterTitle>
        </Dropdown.Header>
        <Body
          updateService={updateService}
          filterMethod={filterMethod}
          isDataUpdated={isDataUpdated}
          sortBy={sortBy}
          onChangeSort={setSortBy}
          filterData={filterData}
          onChangeFilterData={onChangeFilterData}
        />
      </Dropdown.Container>
    </Dropdown.Root>
  );
}

FilterProviders.defaultProps = {
  data: [],
  filterMethod: 'query',
}

FilterProviders.propTypes = {
  updateService: PropTypes.func,
  data: PropTypes.array,
  filterMethod: PropTypes.string,
};

export default memo(FilterProviders);
